const RX_MANAGEMENT = [
  { value: 'Full', text: 'Full' },
  { value: 'Overdue Alerts Only', text: 'Overdue Only' },
  { value: 'None', text: 'None' }
];

type RX_MANAGEMENT = typeof RX_MANAGEMENT;

export default RX_MANAGEMENT;
